import { MDSText } from '@midwest/web/base';
import { MDSHStack, MDSVStack } from '@midwest/web/stacks';
import styled from 'styled-components';

export const NavigationLinkContainer = styled(MDSVStack)`
  padding: 2.5rem 0rem 2.5rem 2.5rem;
`;

export const LinkWithArrow = styled.a`
  margin-top: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

export const LinkText = styled(MDSText.BodyRegDefault)`
  font-size: 0.875rem;
  font-weight: 700;
  color: ${(p) => p.theme.midwestColors.sentimentNegativeStrong};
`;

export const HStackContainer = styled(MDSHStack)`
  gap: 4.5rem;
`;
